import React, { useState, useEffect } from "react";
import { getAllRegistros, addRegistro, deleteRegistro, getAllFavoritos, addFavorito, deleteFavorito, returnDb } from "./db";
import FavoritoItem from './FavoritoItem';
import MultiplicadoresSelecionados from './MultiplicadoresSelecionados'; // Certifique-se de ajustar o caminho para o arquivo correto
import { ToastContainer, toast } from 'react-toastify'; 
import 'react-toastify/dist/ReactToastify.css'; // Estilos do Toast
interface Registro {
  id?: number;
  descricao: string;
  multiplicador: number;
  multiplicaDano: boolean;
}

interface Favorito {
  id?: number;
  nome: string;
  registros: Registro[];
}

const App: React.FC = () => {
  const [registros, setRegistros] = useState<Registro[]>([]);
  const [selectedIds, setSelectedIds] = useState<number[]>([]); // Para manter o controle de quais registros foram selecionados
  const [showModal, setShowModal] = useState(false); // Modal de adicionar registro
  const [descricao, setDescricao] = useState("");
  const [multiplicador, setMultiplicador] = useState(1);
  const [multiplicaDano, setMultiplicaDano] = useState(false);
  const [trigger, setTrigger] = useState(0);

  const [favoritos, setFavoritos] = useState<Favorito[]>([]); // Para armazenar os favoritos
  const [showFavoritoModal, setShowFavoritoModal] = useState(false); // Modal de favoritos
  const [favoritoNome, setFavoritoNome] = useState(""); // Nome do favorito
  const [showConfirmModal, setShowConfirmModal] = useState(false); // Estado para mostrar o modal de confirmação
  const [registroIdToDelete, setRegistroIdToDelete] = useState<number | null>(null); // ID do registro a ser excluído
  const [favoritoNomeToDelete, setFavoritoNomeToDelete] = useState<number | null>(null); // Nome do favorito a ser excluído
  const handleExportData = async () => {
    const allRegistros = await getAllRegistros();
    const allFavoritos = await getAllFavoritos();
  
    const data = {
      registros: allRegistros,
      favoritos: allFavoritos,
    };
  
    const blob = new Blob([JSON.stringify(data, null, 2)], {
      type: "application/json",
    });
  
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "dados.json";
    link.click();
    URL.revokeObjectURL(url);
  };
  const handleDeleteFavorito = (nome: number) => {
    setFavoritoNomeToDelete(nome); // Armazenar o nome do favorito a ser excluído
    setShowConfirmModal(true); // Mostrar o modal de confirmação
  };
  const handleImportData = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;
  
    const reader = new FileReader();
    reader.onload = async (e) => {
      const text = e.target?.result as string;
      const db = await returnDb();
      const transaction = db.transaction(["Registros", "favoritos"], "readwrite");
      try {
        const { registros, favoritos } = JSON.parse(text);
        
        if (Array.isArray(registros)) {
          const registrosStore = transaction.objectStore("Registros");
          await registrosStore.clear();
          for (const registro of registros) {
            registrosStore.add(registro)
          }
        }
  
        if (Array.isArray(favoritos)) {
          const favoritosStore = transaction.objectStore("favoritos");
          await favoritosStore.clear();
          for (const favorito of favoritos) {
            favoritosStore.add(favorito);
          }
        }
  
        // Atualiza os estados após a importação
        await transaction.done;
        refreshData();
        updateStates();
        alert("Dados importados com sucesso!");
      } catch (error) {
        transaction.abort();
        console.error("Erro ao importar os dados:", error);
        alert("Erro ao importar os dados. Verifique o arquivo e tente novamente.");
      }
    };
  
    reader.readAsText(file);
  };
  const updateStates = async () => {
    setRegistros(await getAllRegistros());
    setFavoritos(await getAllFavoritos());
  };
  // Carregar todos os registros do banco
  useEffect(() => {
    const fetchData = async () => {
      const data = await getAllRegistros();
      setRegistros(data);
      const favoritosData = await getAllFavoritos(); // Carregar favoritos do banco
      setFavoritos(favoritosData);
    };
    fetchData();
  }, [trigger]);

  const refreshData = () => {
    debugger
    setTrigger(prev => prev + 1); 
  };

  
  const handleAddRegistro = async (e: React.FormEvent) => {
    e.preventDefault();
    const novoRegistro: Registro = { descricao, multiplicador, multiplicaDano };
    await addRegistro(novoRegistro); // Salva no IndexedDB
    setRegistros(await getAllRegistros()); // Atualiza a lista de registros
    setDescricao(""); // Limpa o campo de descrição
    setMultiplicador(1); // Limpa o campo de multiplicador
    setMultiplicaDano(false); // Limpa o campo de multiplicaDano
    setShowModal(false); // Fecha o modal de adicionar registro
    toast.success('Registro adicionado com sucesso!', {
      position: "top-right",
      autoClose: 3000, // Tempo de exibição
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const confirmDeleteRegistro = async () => {
    if (registroIdToDelete !== null) {
      await deleteRegistro(registroIdToDelete);
      setRegistros(await getAllRegistros());
      setShowConfirmModal(false); // Fechar o modal de confirmação
      setRegistroIdToDelete(null); // Limpar o ID
      toast.success('Registro excluído com sucesso!', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };



  const toggleSelectRegistro = (id: number) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((selectedId) => selectedId !== id) : [...prev, id]
    );
  };

  const handleAddFavorito = async () => {
    if (!favoritoNome) {
      alert("Por favor, insira um nome para o favorito.");
      return;
    }
  
    // Cria o favorito com os registros selecionados
    const novoFavorito = {
      nome: favoritoNome,
      registros: registros.filter((registro) => selectedIds.includes(registro.id!)),
    };
  
    // Salva o favorito no IndexedDB
    await addFavorito(novoFavorito);
  
    // Atualiza o estado de favoritos
    setFavoritos((prevFavoritos) => [...prevFavoritos, novoFavorito]);
  
    setShowFavoritoModal(false); // Fecha o modal de favoritos
    setFavoritoNome(""); // Limpa o nome do favorito
    setSelectedIds([]); // Limpa a seleção dos registros
    setFavoritos(await getAllFavoritos());
    toast.success('Favorito adicionado com sucesso!', {
      position: "top-right",
      autoClose: 3000, // Tempo de exibição
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };
  const confirmDeleteFavorito = async () => {
    if (favoritoNomeToDelete) {
      await deleteFavorito(favoritoNomeToDelete); // Exclui do banco
    setFavoritos(favoritos.filter((favorito) => favorito.id !== favoritoNomeToDelete)); // Atualiza o estado
      setShowConfirmModal(false); // Fechar o modal de confirmação
      setFavoritoNomeToDelete(null); // Limpar o nome
      toast.success('Favorito excluído com sucesso!', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
  
  const handleDeleteRegistro = async (id: number) => {
    setRegistroIdToDelete(id); // Armazenar o ID do registro a ser excluído
    setShowConfirmModal(true); // Mostrar o modal de confirmação
  };

  // Filtrar os registros selecionados
  const registrosSelecionados = registros.filter((registro) =>
    selectedIds.includes(registro.id!)
  );

  return (
    <div className="min-h-screen flex flex-col items-center p-4">
      <h1 className="text-2xl font-bold mb-6">Lista de Registros</h1>

      {/* Botão para abrir o modal de adicionar registro */}
      <button
        onClick={() => setShowModal(true)}
        className="mb-4 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
      >
        Adicionar Registro
      </button>

      {/* Botão para abrir o modal de favoritos */}
      <button
        onClick={() => setShowFavoritoModal(true)}
        className="mb-4 bg-yellow-600 text-white px-4 py-2 rounded hover:bg-yellow-700"
      >
        Adicionar aos Favoritos
      </button>
{/* Exibindo Multiplicadores dos Registros Selecionados */}
{selectedIds.length > 0 && (
        <MultiplicadoresSelecionados registrosSelecionados={registrosSelecionados} />
      )}
      {/* Lista de Registros */}
      <div className="w-full max-w-2xl bg-white rounded-lg shadow p-4">
        {registros.length === 0 ? (
          <p className="text-gray-500">Nenhum registro encontrado.</p>
        ) : (
          <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {registros.map((registro) => (
              <li
                key={registro.id}
                className={`border p-4 rounded-lg text-gray-700 transition-all duration-300 ease-in-out transform ${
                  selectedIds.includes(registro.id!)
                    ? "bg-green-100"
                    : "bg-white"
                } hover:scale-105 hover:shadow-lg`}
                onClick={() => toggleSelectRegistro(registro.id!)}
              >
                <p>
                  <strong>Descrição:</strong> {registro.descricao}
                </p>
                <p>
                  <strong>Multiplicador:</strong> {registro.multiplicador}
                </p>
                <p>
                  <strong>Multiplica o Dano:</strong>{" "}
                  {registro.multiplicaDano ? "Sim" : "Não"}
                </p>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDeleteRegistro(registro.id ?? 0);
                  }}
                  className="mt-2 bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
                >
                  Excluir
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>

      

      {/* Modal de Adicionar Registro */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
            <h2 className="text-xl font-bold mb-4">Adicionar Registro</h2>
            <form onSubmit={handleAddRegistro} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Descrição
                </label>
                <input
                  type="text"
                  value={descricao}
                  onChange={(e) => setDescricao(e.target.value)}
                  className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md text-sm shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Multiplicador
                </label>
                <input
                  type="number"
                  value={multiplicador}
                  onChange={(e) => setMultiplicador(Number(e.target.value))}
                  min="1"
                  className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md text-sm shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
              <div className="flex items-center">
                <input
                  type="checkbox"
                  checked={multiplicaDano}
                  onChange={() => setMultiplicaDano(!multiplicaDano)}
                  className="mr-2"
                />
                <label className="text-sm text-gray-700">
                  Multiplica o Dano
                </label>
              </div>
              <div className="flex justify-end mt-4">
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="mr-4 text-gray-500 hover:text-gray-700"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                >
                  Adicionar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal de Favoritos */}
      {showFavoritoModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
            <h2 className="text-xl font-bold mb-4">Adicionar aos Favoritos</h2>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Nome do Favorito
              </label>
              <input
                type="text"
                value={favoritoNome}
                onChange={(e) => setFavoritoNome(e.target.value)}
                className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md text-sm shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>
            <div className="mt-4">
              <h3 className="text-lg font-semibold">Selecione os Registros</h3>
              <ul>
                {registros.map((registro) => (
                  <li
                    key={registro.id}
                    className={`flex items-center py-2 ${
                      selectedIds.includes(registro.id!)
                        ? "bg-yellow-200"
                        : "bg-white"
                    }`}
                    onClick={() => toggleSelectRegistro(registro.id!)}
                  >
                    <input
                      type="checkbox"
                      checked={selectedIds.includes(registro.id!)}
                      onChange={() => toggleSelectRegistro(registro.id!)}
                      className="mr-2"
                    />
                    <span>{registro.descricao}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="flex justify-end space-x-4 mt-4">
              <button
                type="button"
                onClick={() => setShowFavoritoModal(false)}
                className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
              >
                Cancelar
              </button>
              <button
                onClick={handleAddFavorito}
                className="bg-yellow-600 text-white px-4 py-2 rounded hover:bg-yellow-700"
              >
                Salvar
              </button>
            </div>
          </div>
        </div>
      )}

      <h1 className="text-2xl font-bold mb-6">Favoritos</h1>
      <div className="w-full max-w-2xl bg-white rounded-lg shadow p-4">
  {favoritos.length === 0 ? (
    <p className="text-gray-500">Nenhum favorito encontrado.</p>
  ) : (
    <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {favoritos.map((favorito) => (
        <FavoritoItem
          key={favorito.id}
          favorito={favorito}
          onDelete={(id) => handleDeleteFavorito(id)} 
        />
      ))}
    </ul>
  )}
</div>
<div className="flex space-x-4 mt-4">
  <button
    onClick={handleExportData}
    className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
  >
    Exportar Dados
  </button>
  <button
    onClick={() => document.getElementById("fileInput")?.click()}
    className="bg-purple-600 text-white px-4 py-2 rounded hover:bg-purple-700"
  >
    Importar Dados
  </button>
  <input
    id="fileInput"
    type="file"
    accept=".json"
    onChange={handleImportData}
    className="hidden"
  />
</div>
{showConfirmModal && (
        <div className="fixed inset-0 flex justify-center items-center bg-gray-900 bg-opacity-50">
          <div className="bg-white rounded-lg p-6">
            <p className="text-lg mb-4">
              Tem certeza que deseja excluir
              {registroIdToDelete ? " este registro?" : " este favorito?"}
            </p>
            <div className="flex justify-between">
              <button
                onClick={() => setShowConfirmModal(false)}
                className="text-gray-600 bg-gray-200 px-4 py-2 rounded-md"
              >
                Cancelar
              </button>
              <button
                onClick={registroIdToDelete ? confirmDeleteRegistro : confirmDeleteFavorito}
                className="bg-red-600 text-white px-4 py-2 rounded-md"
              >
                Sim, excluir
              </button>
            </div>
          </div>
        </div>
      )}
<ToastContainer />
    </div>
  );
};

export default App;
